(function () {

    'use strict';

    angular.module('asys')
        .controller('ModalZusammenfassungController', ModalZusammenfassungController);

    ModalZusammenfassungController.$inject = [
        '$log',
        '$modalInstance',
        'lodash',
        'AngebotModel',
        'options'
    ];

    function ModalZusammenfassungController($log, $modalInstance, _, AngebotModel, options) {
        var vm = this,
            angebotModel;

        vm.onClose = onClose;

        activate();

        function activate() {
            angebotModel = AngebotModel.get();

            vm.blockZusammenfassungDetailsOptions = _.merge({}, {
                modalInstance: $modalInstance
            }, options);

            $log.log(angebotModel);
        }

        function onClose() {
            $modalInstance.close();
        }
    }

})();
